import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import {
  CompactTableActions,
  CompactTableBulkActions,
  CompactTableExpandAllButton,
  CompactTableFilter,
  CompactTableSearch,
  CompactTableSelectAllRows,
} from '.';

export const CompactTableToolbar = ({ className }: { className?: string }) => {
  return (
    <div css={[styles.flexColumn, styles.toolbar]} className={className}>
      <div css={[styles.flexRow, styles.searchBarRow]}>
        <CompactTableSearch />
        <CompactTableActions />
        <CompactTableFilter />
      </div>
      <div css={[styles.flexRow, styles.selectAllContainer]}>
        <div css={styles.selectAll}>
          <CompactTableSelectAllRows css={styles.selectAllCheckbox} />
          <CompactTableBulkActions />
        </div>
        <CompactTableExpandAllButton css={styles.expandAllButton} />
      </div>
    </div>
  );
};

const styles = {
  flexRow: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${theme.spacing(1)};
  `,
  flexColumn: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `,
  toolbar: css`
    width: 100%;
    gap: ${theme.spacing(3)};
    margin-bottom: ${theme.spacing(3)};
    margin-top: ${theme.spacing(3)};
  `,
  searchBarRow: css`
    padding: ${theme.spacing(0)};
  `,
  selectAllContainer: css`
    align-items: flex-start;
    padding: ${theme.spacing(0, 0, 0, 1)};
    gap: ${theme.spacing(1)};
    flex-wrap: wrap;
  `,
  selectAll: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
  `,
  selectAllCheckbox: css`
    padding: ${theme.spacing(1, 0)};
  `,
  expandAllButton: css`
    margin-top: ${theme.spacing(0.25)};
    padding-left: ${theme.spacing(0.5)};
  `,
};
